import React, { useEffect } from 'react';

import About1 from '../../assets/images/about-us.png';
import About2 from '../../assets/images/alumni1.png';
import About3 from '../../assets/images/scroll2.png';

import AlumniSvg2 from '../../assets/svgs/alumni2.svg';
import AlumniSvg3 from '../../assets/svgs/alumni3.svg';

function Index() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Purple Academy - About Us';
  }, []);

  return (
    <div className="pt-20">
      <section className="relative mb-52">
        <div className="content">
          <div className="md-2:flex">
            <div className="w-full mb-10 md-2:w-[calc(100%-550px)] md-2:mb-0">
              <div className="w-full max-w-[550px] mx-auto text-left md-2:pr-14">
                <h1 className="section-header">About Us</h1>
                <p className="text-base md:text-lg !leading-loose mb-10">
                  Wema Bank is one of Nigeria&apos;s most resilient banks and the pioneer of
                  Africa&apos;s first fully digital bank, ALAT. With over 75 years in the
                  business of banking, we have remained innovative in delivering value to
                  all our stakeholders. To continue and build on this legacy,
                  we seek to groom knights that are equipped with the relevant skills
                  to thrive and excel in business in an ever-changing world.
                </p>
                <p className="text-base md:text-lg !leading-loose mb-10">
                  Purple Academy will help you on your journey to excellence through world-class
                  onboarding experiences, training opportunities, and an intense focus
                  on your career. As a Knight, The Academy invests in you so you can succeed
                  in your role and develop an exciting, dynamic and rewarding career at Wema Bank.
                </p>
                <p className="text-base md:text-lg !leading-loose">
                  Our business has changed a lot, and so has our learning. No matter your role,
                  learning or life stage needs, we are evolving to create a pillar that will
                  support you through every phase and give you a wholesome experience.
                </p>
              </div>
            </div>
            <div className="w-full sm:w-[550px] mx-auto space-y-4">
              <div className="w-full h-[400px] sm:h-[500px] flex space-x-4">
                <div className="w-2/3 bg-gray-300 relative overflow-hidden">
                  <img src={About1} alt="Caring and Sharing" className="interactive-picture" />
                  <div className="absolute bg-white bottom-0 left-0 py-1.5 px-3">
                    <h3 className="text-primary font-title font-bold text-sm">Kitchen</h3>
                    <h3 className="text-xs">Lunch Break at the Academy</h3>
                  </div>
                </div>
                <div className="w-1/3 h-full flex flex-wrap space-y-4">
                  <div className="w-full h-[calc(50%-16px)] bg-[#F1A51C] overflow-hidden relative">
                    <img src={AlumniSvg3} alt="" className="absolute inset-0 w-full h-full object-cover object-bottom" />
                  </div>
                  <div className="w-full h-1/2 bg-gray-300 relative overflow-hidden">
                    <img src={About2} alt="Caring and Sharing" className="interactive-picture" />
                  </div>
                </div>
              </div>
              <div className="w-full h-[230px] sm:h-[300px] flex space-x-4">
                <div className="w-1/2 bg-gray-300 relative overflow-hidden">
                  <img src={About3} alt="Caring and Sharing" className="interactive-picture" />
                </div>
                <div className="w-1/2 h-full flex flex-wrap space-y-4">
                  <div className="w-full h-full overflow-hidden relative">
                    <img src={AlumniSvg2} alt="" className="absolute inset-0 w-full h-full object-cover object-bottom" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Index;
